<template>
  <cargo-user-select
    :default-multiple-value="toNumArray(value)"
    :multiple="true"
    v-bind="$attrs"
    v-on="new$listeners"
    @change="onChange"
  />
</template>

<script>
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'

export default {
  name: 'UserDefinedRoleId8',
  components: {
    cargoUserSelect
  },
  props: {
    value: { type: String, required: true }
  },
  computed: {
    new$listeners() {
      const result = { ...this.$listeners }
      delete result.change
      return result
    }
  },
  methods: {
    onChange(data) {
      const newValue = data instanceof Object ? data.value : data
      const newTxt = this.toTxt(newValue)
      if (newTxt !== this.value) {
        this.$emit('input', newTxt)
        this.$emit('change', newTxt)
      }
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    toTxt(arr) {
      if (arr && arr.length > 0) {
        return arr.join(',')
      }
      return ''
    }
  }
}
</script>
